module.exports = __webpack_public_path__ + "static/wonz-poster-289e9e5bcdbc74b4abd5ee19d62bbf6a.jpg";